import styled from '@emotion/styled';
import { Tooltip } from '@material-ui/core';
import { createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../theme';
import _DraftModificationRequestIcon from './DraftModificationRequestIcon';

const DraftModificationRequestIconWithTooltip = () => {
  return (
    <FormattedMessage id="modification_request_state.draft_exist">
      {(text: string) => (
        <Tooltip placement="top" title={text}>
          <div>
            <DraftModificationRequestIcon size={24} />
          </div>
        </Tooltip>
      )}
    </FormattedMessage>
  );
};

const DraftModificationRequestIcon = styled(_DraftModificationRequestIcon)({
  color: theme.palette.primary.main,
});

export default DraftModificationRequestIconWithTooltip;
